import styled from 'styled-components';
import { Button, BodyText } from '@minerva-analytics/pantheon';

import { 
  LARGE, 
  WHITE,
  MOBILE,
  CANDY_RED,
  BLACK
} from '../../theme';

const ModalTheme = {
  Modal: `
    border-top: ${CANDY_RED} solid 0.5rem;
    max-width: unset;
    justify-content: space-between;
    width: 35rem;
    padding: 2rem 3.75rem;
    background-color: ${WHITE};
    @media (max-width: ${LARGE}){
      width 65%;
      padding: 1.25rem 3.75rem 2rem 3.75rem;
    }
    @media (max-width: ${MOBILE}){
      width: 75%;
      padding: 1rem 2rem 2rem 2rem;
    }
  `,
}

const PriceButton = styled(Button)`
  min-width: 60px;
  margin-right: 1rem;
  @media (max-width: ${MOBILE}){
    min-width: 50px;
    margin-bottom: 0.5rem;
  }
`;

const ModalText = styled(BodyText)`
  color: ${BLACK};

  span {
    font-weight: 900;
  }
`;

const ButtonContainer = styled.div`
  flex-wrap: wrap;
  display: flex;
`;

const PaddedButton = styled(Button)`
  padding: 0.5rem 1.5rem;
`;

const DisclaimerText = styled(BodyText)`
  &&&{
    margin-top: 1.3rem;
    font-size: 1rem;
    line-height: unset;
    color: #c4c4c4;
    font-style: italic;
  }
`;

export {
  ModalTheme,
  PriceButton,
  ButtonContainer,
  ModalText,
  PaddedButton,
  DisclaimerText
};